import { render, staticRenderFns } from "./EventsStatistics.vue?vue&type=template&id=56651790"
import script from "./EventsStatistics.vue?vue&type=script&lang=js"
export * from "./EventsStatistics.vue?vue&type=script&lang=js"
import style0 from "./EventsStatistics.vue?vue&type=style&index=0&id=56651790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports